import { Injectable } from '@angular/core';
import { CountryService } from './country.service';
import { StateService } from './state.service';
import { DivisionService } from './division.service';
import { DistrictService } from './district.service';
import { TalukhaService } from './talukha.service';
import { CityService } from './city.service';
import { RoleService } from './role.service';
import { PermissionService } from './permission.service';
import { UniversityService } from './university.service';
import { StreamService } from './stream.service';
import { ProgramService } from './program.service';
import { CourseService } from './course.service';
import { CollegeService } from './college.service';
import { SubjectService } from './subject.service';
import { ModuleService } from './module.service';
import { SubModuleService } from './sub-module.service';
import { AcademicYearService } from './academic-year.service';
import { ExamService } from './exam.service';
import { LevelService } from './level.service';
import { AssessmentService } from './assessment.service';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root'
})
export class DropdownService {
  private listKeysByFilter: Record<string, string[]> = {
    country: ['country_list'],
    state: ['state_list'],
    division: ['division_list'],
    distric: ['district_list'],
    district: ['district_list'],
    taluka: ['taluka_list'],
    city: ['city_list'],
    role: ['role_list'],
    permission: ['permission_list'],
    university: ['university_list'],
    program: ['program_list'],
    stream: ['stream_list'],
    course: ['course_list'],
    college: ['college_list'],
    'academic-year': ['academic_list'],
    subject: ['subject_list'],
    module: ['module_list'],
    sub_module: ['sub_module_list'],
    exam: ['exam_list', 'exam_code_list'],
    level: ['level_list'],
    student: ['student_list'],
    user: ['user_list'],
    evaluator: ['evaluator_list'],
    assessment: ['assessment_list'],
    assess: ['assess_list'],
    head_evaluator: ['head_evaluator_list'],
  };
  dropdown_list: any = {
    gender_list: [{ title: 'Male', value: 1 }, { title: 'Female', value: 2 }, { title: 'Transgender', value: 3 }]
  }
  constructor(public cs: CountryService, public ss: StateService, public divs: DivisionService, public dits: DistrictService, public tls: TalukhaService, public cts: CityService, public rs: RoleService, public ps: PermissionService, public us: UniversityService, public sts: StreamService, public prs: ProgramService, public crs: CourseService, public cls: CollegeService, public sbs: SubjectService, public ms: ModuleService, public sms: SubModuleService, public ays: AcademicYearService, public es: ExamService, public ls: LevelService, public assessment: AssessmentService, public user: UserService) { }

  async get_dropdown_list(filters: any[]) {
    try {
      const hasFilter = (filter: string | string[]) => {
        if (Array.isArray(filter)) {
          return filter.some((key) => filters.includes(key));
        }
        return filters.includes(filter);
      };
      if (filters.includes('country') && (!this.dropdown_list.country_list || this.dropdown_list.country_list?.length == 0)) {
        let filter = { is_active: true, page_size: 999999999, sort_by: 'name', sort_order: 'ASC' } // DESC
        const country_response = await this.cs.get_list(filter);
        this.dropdown_list.country_list = country_response?.data.map((item: any) => ({ ...item, title: item.name || "none", value: item.id || "none" }));
      }

      if (filters.includes('state') && (!this.dropdown_list.state_list || this.dropdown_list.state_list?.length == 0)) {
        let filter = { is_active: true, page_size: 999999999, sort_by: 'name', sort_order: 'ASC' }
        const state_response = await this.ss.get_list(filter);
        this.dropdown_list.state_list = state_response?.data.map((item: any) => ({ ...item, title: item.name || "none", value: item.id || "none" }));
      }

      if (filters.includes('division') && (!this.dropdown_list.division_list || this.dropdown_list.division_list?.length == 0)) {
        let filter = { is_active: true, page_size: 999999999, sort_by: 'name', sort_order: 'ASC' }
        const division_response = await this.divs.get_list(filter);
        this.dropdown_list.division_list = division_response?.data.map((item: any) => ({ ...item, title: item.name || "none", value: item.id || "none" }));
      }

      if (hasFilter(['distric', 'district']) && (!this.dropdown_list.district_list || this.dropdown_list.district_list?.length == 0)) {
        let filter = { is_active: true, page_size: 999999999, sort_by: 'name', sort_order: 'ASC' }
        const district_response = await this.dits.get_list(filter);
        this.dropdown_list.district_list = district_response?.data.map((item: any) => ({ ...item, title: item.name || "none", value: item.id || "none" }));
      }
      if (filters.includes('taluka') && (!this.dropdown_list.taluka_list || this.dropdown_list.taluka_list?.length == 0)) {
        let filter = { is_active: true, page_size: 999999999, sort_by: 'name', sort_order: 'ASC' }
        const taluka_response = await this.tls.get_list(filter);
        this.dropdown_list.taluka_list = taluka_response?.data.map((item: any) => ({ ...item, title: item.name || "none", value: item.id || "none" }));
      }
      if (filters.includes('city') && (!this.dropdown_list.city_list || this.dropdown_list.city_list?.length == 0)) {
        let filter = { is_active: true, page_size: 999999999, sort_by: 'name', sort_order: 'ASC' }
        const city_response = await this.cts.get_list(filter);
        this.dropdown_list.city_list = city_response?.data.map((item: any) => ({ ...item, title: item.name || "none", value: item.id || "none" }));
      }
      if (filters.includes('role') && (!this.dropdown_list.role_list || this.dropdown_list.role_list?.length == 0)) {
        let filter = { page_size: 999999999, sort_by: 'name', sort_order: 'ASC' }
        const city_response = await this.rs.get_list(filter);
        this.dropdown_list.role_list = city_response?.data.map((item: any) => ({ ...item, title: item.name || "none", value: item.id || "none" }));
      }
      if (filters.includes('permission') && (!this.dropdown_list.permission_list || this.dropdown_list.permission_list?.length == 0)) {
        let filter = { is_active: true, page_size: 999999999, sort_by: 'name', sort_order: 'ASC' }
        const city_response = await this.ps.get_list(filter);
        this.dropdown_list.permission_list = city_response?.data.map((item: any) => ({ ...item, title: item.name || "none", value: item.id || "none" }));
      }
      if (filters.includes('university') && (!this.dropdown_list.university_list || this.dropdown_list.university_list?.length == 0)) {
        let filter = { is_active: true, page_size: 999999999, sort_by: 'name', sort_order: 'ASC' }
        const city_response = await this.us.get_list(filter);
        this.dropdown_list.university_list = city_response?.data.map((item: any) => ({ ...item, title: item.name || "none", value: item.id || "none" }));
      }
      if (filters.includes('program') && (!this.dropdown_list.program_list || this.dropdown_list.program_list?.length == 0)) {
        let filter = { is_active: true, page_size: 999999999, sort_by: 'name', sort_order: 'ASC' }
        const city_response = await this.prs.get_list(filter);
        this.dropdown_list.program_list = city_response?.data.map((item: any) => ({ ...item, title: item.name || "none", value: item.id || "none" }));
      }
      if (filters.includes('stream') && (!this.dropdown_list.stream_list || this.dropdown_list.stream_list?.length == 0)) {
        let filter = { is_active: true, page_size: 999999999, sort_by: 'name', sort_order: 'ASC' }
        const city_response = await this.sts.get_list(filter);
        this.dropdown_list.stream_list = city_response?.data.map((item: any) => ({ ...item, title: item.name || "none", value: item.id || "none" }));
      }
      if (filters.includes('course') && (!this.dropdown_list.course_list || this.dropdown_list.course_list?.length == 0)) {
        let filter = { is_active: true, page_size: 999999999, sort_by: 'name', sort_order: 'ASC' }
        const city_response = await this.crs.get_list(filter);
        this.dropdown_list.course_list = city_response?.data.map((item: any) => ({ ...item, title: item.name || "none", value: item.id || "none" }));
      }
      if (filters.includes('college') && (!this.dropdown_list.college_list || this.dropdown_list.college_list?.length == 0)) {
        let filter = { is_active: true, page_size: 999999999, sort_by: 'name', sort_order: 'ASC' }
        const city_response = await this.cls.get_list(filter);
        this.dropdown_list.college_list = city_response?.data.map((item: any) => ({ ...item, title: item.name || "none", value: item.id || "none" }));
      }
      if (filters.includes('academic-year') && (!this.dropdown_list.academic_list || this.dropdown_list.academic_list?.length == 0)) {
        let filter = { is_active: true, page_size: 999999999, sort_by: 'name', sort_order: 'ASC' }
        const city_response = await this.ays.get_list(filter);
        this.dropdown_list.academic_list = city_response?.data.map((item: any) => ({ ...item, title: item.name || "none", value: item.id || "none" }));
      }
      if (filters.includes('subject') && (!this.dropdown_list.subject_list || this.dropdown_list.subject_list?.length == 0)) {
        let filter = { is_active: true, page_size: 999999999, sort_by: 'name', sort_order: 'ASC' }
        const city_response = await this.sbs.get_list(filter);
        this.dropdown_list.subject_list = city_response?.data.map((item: any) => ({ ...item, title: (item.name || "none") + (item.code ? ' (' + item.code + ')' : ''), value: item.id || "none" }));
      }
      if (filters.includes('module') && (!this.dropdown_list.module_list || this.dropdown_list.module_list?.length == 0)) {
        let filter = { is_active: true, page_size: 999999999, sort_by: 'name', sort_order: 'ASC' }
        const city_response = await this.ms.get_list(filter);
        this.dropdown_list.module_list = city_response?.data.map((item: any) => ({ ...item, title: item.name || "none", value: item.id || "none" }));
      }
      if (filters.includes('sub_module') && (!this.dropdown_list.sub_module_list || this.dropdown_list.sub_module_list?.length == 0)) {
        let filter = { is_active: true, page_size: 999999999, sort_by: 'name', sort_order: 'ASC' }
        const city_response = await this.sms.get_list(filter);
        this.dropdown_list.sub_module_list = city_response?.data.map((item: any) => ({ ...item, title: item.name || "none", value: item.id || "none" }));
        console.log(city_response, 1111);
      }
      if (filters.includes('exam') && (!this.dropdown_list.exam_list || this.dropdown_list.exam_list?.length == 0)) {
        let filter = { is_active: true, page_size: 999999999, sort_by: 'name', sort_order: 'ASC' }
        const city_response = await this.es.get_list(filter);
        this.dropdown_list.exam_list = city_response?.data.map((item: any) => ({ ...item, title: item.name || "none", value: item.id || "none" }));
        this.dropdown_list.exam_code_list = city_response?.data.map((item: any) => ({ ...item, title: item.code || "none", value: item.id || "none" }));
        this.dropdown_list.exam_name_and_code_list = city_response?.data.map((item: any) => ({ ...item, title: (item.name || "none") + (item.code ? ' (' + item.code + ')' : ''), value: item.id || "none" }));
      }
      if (filters.includes('level') && (!this.dropdown_list.level_list || this.dropdown_list.level_list?.length == 0)) {
        let filter = { is_active: true, page_size: 999999999, sort_by: 'name', sort_order: 'ASC' }
        const city_response = await this.ls.get_list(filter);
        this.dropdown_list.level_list = city_response?.data.map((item: any) => ({ ...item, title: item.name || "none", value: item.id || "none" }));
      }
      if (filters.includes('student') && (!this.dropdown_list.student_list || this.dropdown_list.student_list?.length == 0)) {
        let filter = { is_active: true, page_size: 999999999, sort_by: 'name', sort_order: 'ASC', user_type: 'student' }
        const city_response = await this.user.get_list(filter);
        this.dropdown_list.student_list = city_response?.data.map((item: any) => ({ ...item, title: item.roll_number || "none", value: item.id || "none" }));
        this.dropdown_list.student_name_list = city_response?.data.map((item: any) => ({ ...item, title: item.registration_number || "none", value: item.id || "none" }));
      }
      if (filters.includes('user') && (!this.dropdown_list.user_list || this.dropdown_list.user_list?.length == 0)) {
        let filter = { is_active: true, page_size: 999999999, sort_by: 'name', sort_order: 'ASC', }
        const response = await this.user.get_list(filter);
        this.dropdown_list.user_list = response?.data.map((item: any) => ({ ...item, title: item.name || "none", value: item.id || "none" }));
      }
      if (filters.includes('evaluator') && (!this.dropdown_list.evaluator_list || this.dropdown_list.evaluator_list?.length == 0)) {
        let filter = { is_active: true, page_size: 999999999, sort_by: 'name', sort_order: 'ASC', role: 'Evaluator', evaluator: true }
        const response = await this.user.get_list(filter);
        this.dropdown_list.evaluator_list = response?.data.map((item: any) => ({ ...item, title: item.name || "none", value: item.id || "none" }));
      }
      if (filters.includes('head_evaluator') && (!this.dropdown_list.head_evaluator_list || this.dropdown_list.head_evaluator_list?.length == 0)) {
        let filter = { is_active: true, page_size: 999999999, sort_by: 'name', sort_order: 'ASC', role: 'Head Evaluator', head_evaluator: true }
        const response = await this.user.get_list(filter);
        this.dropdown_list.head_evaluator_list = response?.data.map((item: any) => ({ ...item, title: item.name || "none", value: item.id || "none" }));
      }
      if (filters.includes('manual_assessment') && (!this.dropdown_list.manual_assessment_list || this.dropdown_list.manual_assessment_list?.length == 0)) {
        let filter = { page_size: 999999999, sort_by: 'name', sort_order: 'ASC', assessment_type: 'Manual' }
        const assessment_response = await this.assessment.get_list(filter);
        this.dropdown_list.manual_assessment_list = assessment_response?.data.map((item: any) => ({ ...item, title: item.Subject.name || "none", value: item.id || "none", }));
        console.log(this.dropdown_list.manual_assessment_list, 'dropdown');

      }
      if (filters.includes('assessment') && (!this.dropdown_list.assessment_list || this.dropdown_list.assessment_list?.length == 0)) {
        let filter = { is_active: true, page_size: 999999999, sort_by: 'name', sort_order: 'ASC' }
        const assessment_response = await this.assessment.get_list({});
        this.dropdown_list.assessment_list = assessment_response?.data.map((item: any) => ({
          ...item,
          title: item.Subject.name || "none",
          value: item.id || "none",
          exam_id: item.Exam?.id || 'none',
          college_id: item.College?.id,
          no_of_evaluation: item.no_of_evaluation,
          // Map Uppercase API keys to lowercase for component compatibility
          college: item.College,
          exam: item.Exam,
          subject: item.Subject,
          university: item.University,
          academic_year: item.AcademicYear,
          level: item.Level,
          program: item.Program,
          stream: item.Stream
        }));
        console.log(this.dropdown_list.assessment_list, 'dropdown');
        this.dropdown_list.assessment_name_and_code_list = assessment_response?.data.map((item: any) => ({ ...item, title: (item.Subject.name || "none") + (item.Subject.code ? ' (' + item.Subject.code + ')' : ''), value: item.id || "none" }));

      }
      if (filters.includes('assess') && (!this.dropdown_list.assess_list || this.dropdown_list.assess_list?.length == 0)) {
        let filter = { is_active: true, page_size: 999999999, sort_by: 'name', sort_order: 'ASC' }
        const assessment_response = await this.assessment.get_list({});
        this.dropdown_list.assess_list = assessment_response?.data.map((item: any) => ({
          ...item,
          title: item?.Subject?.name || "none",
          value: item?.subject_id || "none",
          assessment_id: item?.id || null,
          exam_id: item.Exam?.id || 'none',
          college_id: item.College?.id,
          // Map Uppercase API keys to lowercase for component compatibility
          college: item.College,
          exam: item.Exam,
          subject: item.Subject,
          university: item.University,
          academic_year: item.AcademicYear,
          level: item.Level,
          program: item.Program,
          stream: item.Stream
        }));
        console.log(this.dropdown_list.assessment_list, 'dropdown');

      }
      // if (filters.includes('city') && (!this.dropdown_list.city_list || this.dropdown_list.city_list?.length == 0)) {
      //     this.city_response = await this.city.get_list({ show_in_list: true, is_active: true ,page:1, page_size:999999});
      //     this.dropdown_list.city_list = this.city_response?.data.map((item: any) => ({ ...item, title: item.name || "none", value: item.id || "none" }));
      //   }

    } catch (error: any) {
      throw error;
    }
  }

  invalidate_dropdown_cache(filters: string[] | string) {
    const list = Array.isArray(filters) ? filters : [filters];
    list.forEach((filter) => {
      const keys = this.listKeysByFilter[filter] || [];
      keys.forEach((key) => {
        delete this.dropdown_list[key];
      });
    });
  }

  async refresh_dropdown_list(filters: string[]) {
    this.invalidate_dropdown_cache(filters);
    return this.get_dropdown_list(filters);
  }

  get_title_by_id(list_key: string, id: number | string): string {
    const list = this.dropdown_list?.[list_key];
    if (!Array.isArray(list)) return '—';

    return list.find((item: any) => item.value === id)?.title ?? '—';
  }

  async get_students_by_subject(subject_id: any, exam_id: any) {
    try {
      const filter: any = {
        is_active: true,
        page_size: 999999999,
        sort_by: 'name',
        sort_order: 'ASC',
        user_type: 'student',
        subject_id: subject_id,
        exam_id: exam_id
      };
      const response = await this.user.get_list(filter);
      const result: any[] = [];
      for (const item of (response?.data || [])) {
        const mapping = (item.StudentMappings || []).find((m: any) =>
          m.exam_id == exam_id && Array.isArray(m.subject_ids) && m.subject_ids.includes(+subject_id)
        );
        if (mapping?.roll_number) {
          result.push({ ...item, title: mapping.roll_number, value: item.id });
        }
      }
      return result;
    } catch (error) {
      console.error('Error fetching students by subject:', error);
      return [];
    }
  }

  async get_evaluators_by_subject(subject_id: number, role_type: 'evaluator' | 'head_evaluator' = 'evaluator') {
    try {
      let filter: any = {
        is_active: true,
        page_size: 999999999,
        sort_by: 'name',
        sort_order: 'ASC',
        subject_id: subject_id
      }

      if (role_type === 'evaluator') {
        filter.role = 'Evaluator';
        filter.evaluator = true;
      } else if (role_type === 'head_evaluator') {
        filter.role = 'Head Evaluator';
        filter.head_evaluator = true;
      }

      const response = await this.user.get_list(filter);
      return response?.data.map((item: any) => ({ ...item, title: item.name || "none", value: item.id || "none" }));
    } catch (error) {
      console.error(`Error fetching ${role_type}s by subject:`, error);
      return [];
    }
  }
}
